<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<h1>Copyright Information ©</h1>
<p><strong>Marvin Kistler (2020)</strong></p>
<p>All rights reserved. No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other non-commercial uses permitted by copyright law. For permission requests, write to the publisher.</p>
<p>Any person who commits any unauthorized act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p>
<p><strong>Ordering Information:</strong></p>
<p>Quantity sales: special discounts are available on quantity purchases by corporations, associations, and others. For details, contact the publisher at the address below.</p>
<p><strong>Publisher’s Cataloging-in-Publication data</strong></p>
<p>Kistler, Marvin</p>
<p>Emotional Freedom with No Fear, No Anger, and No Insecurity</p>
<p>ISBN 9781641827492 (Paperback)</p>
<p>ISBN 9781641827508 (Hardback)</p>
<p>ISBN 9781645364702 (ePub e-book)</p>
<p>Library of Congress Control Number: 2019907934</p>
<p>www.austinmacauley.com/us</p>
<p>First Published (2020)</p>
<p>Austin Macauley Publishers LLC</p>
<p>40 Wall Street, 28th Floor</p>
<p>New York, NY 10005</p>
<p>USA</p>
<p>mail-usa@austinmacauley.com</p>
<p>+1 (646) 5125767</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?dbb44cec